import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { CustomAvatar } from '@app/components/custom-avatar';
import { StatusTag } from '@app/components';
import { ClientStatus } from '@app/constants';
import { TableCellCustom } from '@app/components/table';
import { IClient } from '../types';
import { RowActions } from './row-actions';
import { PATH_DASHBOARD } from '@app/routes/paths';
interface Props {
  row: IClient;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddClient: string;
}

const ClientRow = (props: Props) => {
  const { row, canAddClient } = props;
  const navigate = useNavigate();
  const handleDetails = () => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`${PATH_DASHBOARD.clientDetail}/${row?.firstName}`, { state: { id: row.id } });
  };

  return (
    <>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center" width={180} onClick={handleDetails}>
        <Stack
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '9px',
            cursor: 'pointer',
          }}
        >
          <CustomAvatar
            name={`${row.firstName} ${row.lastName}`}
            color="info"
            alt="pic"
            src={row.image}
          />
          <Typography variant="body2">
            {row?.firstName} {row?.lastName}
          </Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom align="center" onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row?.email}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center" onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.phone ? row?.phone : 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        align="center"
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
      >
        <StatusTag status={ClientStatus[row?.status ? 1 : 0]} />
      </TableCellCustom>
      {canAddClient ? (
        <TableCellCustom align="center" width={50} style={{ cursor: 'pointer' }}>
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { ClientRow };
